<div class="detail-page-card">
    @if (label ?? ("historyOverview.defaultLabel" | transloco); as cardTitle) {
        <div class="detail-page-card-title">{{ cardTitle }}</div>
    }
    @if (isValidObject) {
        <div class="detail-page-card-actions">
            <button
                data-uiid="reload-button"
                class="btn btn-raised"
                (click)="loadHistory()"
                [disabled]="isLoading"
            >
                <i class="fas fa-sync"></i>
                <span>{{ "historyOverview.reloadButton" | transloco }}</span>
            </button>
        </div>
    }

    @if (isLoading) {
        <div class="fancy-loader my-4"></div>
    } @else {
        @if (historyModels) {
            <div class="detail-page-card-body flush-expansion-panels">
                <mat-accordion data-uiid="history-table">
                    @for (historyModel of historyModels; track historyModel; let i = $index) {
                        <mat-expansion-panel (opened)="loadChanges(historyModel)">
                            <mat-expansion-panel-header
                                [attr.data-uiid]="'history-table-row-header' + i"
                            >
                                <mat-panel-title [attr.data-uiid]="'history-table-row-title-' + i">
                                    {{ historyModel.MutationDate | dateTimeFormat: true }}
                                </mat-panel-title>
                                <mat-panel-description
                                    [attr.data-uiid]="'history-table-row-description-' + i"
                                >
                                    {{
                                        "historyOverview.mutationByUser"
                                            | transloco
                                                : {
                                                      action:
                                                          historyModel.MutationAction ?? "",
                                                      user: historyModel.UserName ?? "",
                                                  }
                                    }}
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <ng-template matExpansionPanelContent>
                                @if (historyModel.CombinedChanges) {
                                    <history-detail
                                        [changes]="historyModel.CombinedChanges"
                                        data-uiid="history-table-row-body"
                                    >
                                    </history-detail>
                                } @else {
                                    <div class="fancy-loader submodule my-4"></div>
                                }
                            </ng-template>
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            </div>
        } @else {
            <div class="detail-page-card-body padded text-center">
                {{ "historyOverview.notAvailable" | transloco }}
            </div>
        }
    }
</div>
